import Controller from '@ember/controller'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import { tracked } from '@glimmer/tracking'
import type FastPhonicsProgressReviewStudentsRoute from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/review/students/route'
import {
  serialize as serializeSort,
  deserialize as deserializeSort,
  updateSortColumns,
} from '@blakeelearning/data-tables/utils/sorting'

export default class FastPhonicsReportingProgressReviewStudentsController extends Controller<
  ModelFor<FastPhonicsProgressReviewStudentsRoute>
> {
  @service router!: RouterService

  queryParams = ['sort', 'pageNumber', 'perPage']

  @tracked sort = 'first_name'

  @tracked pageNumber = 1

  @tracked perPage = 10

  get sortingConfig() {
    return deserializeSort(this.sort)
  }

  set sortingConfig(newSortConfig) {
    this.sort = serializeSort(newSortConfig)
  }

  get paginationConfig() {
    return { pageNumber: Number(this.pageNumber), perPage: Number(this.perPage) }
  }

  updateSorts = ({ sortKey }: SortObject) => {
    if (sortKey) {
      const newSortConfig = updateSortColumns(this.sortingConfig, sortKey as string)
      this.sortingConfig = newSortConfig
    }
  }

  transitionToStudentRoute = (studentId: string) => {
    void this.router.transitionTo('reporting.ui-scope.fast-phonics.progress.student.table', studentId)
  }
}
